<template>
  <article class="recently-reviewed-by-experts">
    <header v-if="!loading.reviews">
      <h1>Recently Reviewed by the Experts</h1>
      <router-link :to="`/expert`">See all</router-link>
    </header>
    <section>
      <carousel
        v-if="!loading.reviews"
        :per-page="isDesktop ? 3 : 1"
        :navigation-enabled="false"
        navigation-next-label
        navigation-prev-label
        pagination-color="#E5E5E5"
        pagination-active-color="#F384A7"
        class="recent-review-carousel"
      >
        <slide v-for="(review, key) in expertReviews" :key="`meet-our-experts-${key}`" class="slides">
          <CardReviewExpert
            :key="`CardReviewDetail-${key}`"
            :review-data="review"
            :show-bookmark="true"
            :is-expert-review="review.user.is_expert_reviewer"
            object_type="recent_reviews"
            on="expert"
          />
        </slide>
      </carousel>
      <ExpertReviewLoader v-else />
    </section>
    <ModalReport />
  </article>
</template>
<script>
const Config = require('~/config/default.env').default;
export default {
  name: 'ExpertPage',
  components: {
    CardReviewExpert: () => import('@/components/dashboard/snippet/card-review-expert'),
    ModalReport: () => import('@/components/global/modal/modal-report'),
    ExpertReviewLoader: () => import('@/components/global/loader/expert-review-loader'),
  },
  data() {
    return {
      reviews: [],
      options: {
        limit: 10,
        skip: 0,
      },
      loading: {
        reviews: true,
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    expertReviews() {
      return this.$store.state.review.expert;
    },
  },
  created() {
    this.fetchRecentReviews();
  },
  methods: {
    async fetchRecentReviews() {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/reviews', {
              params: {
                filter: {
                  object_type: 'add-review',
                  'user.is_expert_reviewer': true,
                },
                skip: this.options.skip,
                limit: this.options.limit,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        // this.reviews = data.data;
        this.$store.commit('review/SET_REVIEW', {
          reviews: data.data,
          on: 'expert',
        });
        this.loading.reviews = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';
@mixin sectionHeader() {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    margin: 0;
    font-family: $lato-bold;
    font-size: 16px;
    line-height: 22px;
    color: #231f20;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  a {
    color: #b22655;
    font-size: 13px;
    line-height: 15px;
    font-family: 'Lato-Medium', sans-serif;
    font-weight: 700;
  }
}

@mixin carousel() {
  &::v-deep {
    .VueCarousel-wrapper {
      padding-bottom: 10px;
    }
    .VueCarousel-pagination {
      bottom: 0;
      .VueCarousel-dot-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        button.VueCarousel-dot {
          padding: 0 !important;
          height: 6px !important;
          width: 6px !important;
          &--active {
            height: 10px !important;
            width: 10px !important;
          }
        }
      }
    }
    .VueCarousel-navigation-prev {
      left: 15px;
    }
    .VueCarousel-navigation-next {
      right: 15px;
    }
  }
}

.recently-reviewed-by-experts {
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  margin-bottom: 20px;
  @media (max-width: 991px) {
    margin-bottom: 0;
    padding: 16px;
  }
  header {
    @include sectionHeader();
  }
  .recent-review-carousel {
    @include carousel();
    &::v-deep .VueCarousel-inner {
      margin-right: -8px;
      .VueCarousel-slide {
        position: relative;
        @media (max-width: 768px) {
          left: -5px;
        }
      }
    }
    &::v-deep {
      .VueCarousel-wrapper {
        padding-bottom: 32px;
      }
    }
  }
}
</style>
